import { getFilterFieldDatasource } from "./getFilterFieldDatasource";

interface DatasourceSortableField {
  label?: string;
  related_datasources?: readonly string[] | null;
}

const compareText = (a = "", b = ""): number =>
  a.localeCompare(b, undefined, { sensitivity: "base" });

export const sortFieldsByDatasource = <T extends DatasourceSortableField>(
  fields: readonly T[]
): T[] =>
  fields
    .map((field) => ({
      field,
      datasource: getFilterFieldDatasource(field.related_datasources),
    }))
    .sort((a, b) => {
      if (!a.datasource !== !b.datasource) {
        return a.datasource ? 1 : -1;
      }

      return (
        compareText(a.datasource, b.datasource) ||
        compareText(a.field.label, b.field.label)
      );
    })
    .map(({ field }) => field);
